export default "__VITE_ASSET__BkT2FGU1__"